import { render, staticRenderFns } from "./valuation_class.vue?vue&type=template&id=24dc1759"
import script from "./valuation_class.vue?vue&type=script&lang=js"
export * from "./valuation_class.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports